import { Box, Button } from '@factorialco/deprecated-design-system'
import { ContractVersionPageContractVersionFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import useGraphqlContracts from 'modules/contracts/hooks/useGraphlContracts'
import { hasOngoing } from 'modules/contracts/lib/graphqlContractVersionSchedule'

import Menu from './Menu'

interface Props {
  employeeId: number
  selectedContractVersion: ContractVersionPageContractVersionFragment
  allContractVersions: ContractVersionPageContractVersionFragment[]
  hasContractVersionRequest: boolean
  onClickEdit: () => void
  onClickFix: () => void
  onClickDelete: () => void
  toggleHistory: () => void
}

const Actions = ({
  employeeId,
  selectedContractVersion,
  allContractVersions,
  onClickEdit,
  onClickFix,
  onClickDelete,
  toggleHistory,
  hasContractVersionRequest,
}: Props) => {
  const canEdit = !!selectedContractVersion._policies?.edit?.can
  const canPromote = !!selectedContractVersion._policies?.promote?.can

  const canDeleteContracts = !!selectedContractVersion._policies?.delete?.can
  const canSeeMenu = canEdit || canDeleteContracts
  const { contracts } = useGraphqlContracts(selectedContractVersion, allContractVersions)
  const canUpdateContract = canEdit || (canPromote && hasOngoing(contracts))

  return (
    <Box
      gridColSpan={{ xxs: 12, xs: 6, s: 5 }}
      flexDirection="row"
      justifyContent="flexEnd"
      gap="s8"
    >
      {canUpdateContract && (
        <Box className="employee_profile_contracts_tab_new_conditions_button">
          <Button type="primary" onClick={() => onClickEdit()} iconName="add">
            {i18n.t('contract_versions.header.new_conditions')}
          </Button>
        </Box>
      )}

      <Button type="secondary" onClick={() => toggleHistory()} iconName="clock">
        {i18n.t('contract_versions.header.history')}
      </Button>
      {canSeeMenu && (
        <Menu
          employeeId={employeeId}
          selectedContractVersion={selectedContractVersion}
          allContractVersions={allContractVersions}
          onClickFix={onClickFix}
          onClickDelete={onClickDelete}
          hasContractVersionRequest={hasContractVersionRequest}
        />
      )}
    </Box>
  )
}

export default observer(Actions)
